import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { Footer, Header } from '@components';
import { StyledMain, StyledPublicWrapper } from './public-layout.styles';
import { StyledContainer, StyledContainerWrapper } from '@hocs/layouts/private-layout/private-layout.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PublicLayout = function PublicLayout(_ref) {
  var inline = _ref.inline,
      _ref$isFooterVisible = _ref.isFooterVisible,
      isFooterVisible = _ref$isFooterVisible === void 0 ? true : _ref$isFooterVisible;
  return /*#__PURE__*/_jsx(StyledPublicWrapper, {
    children: /*#__PURE__*/_jsxs(Box, {
      flex: 1,
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(StyledMain, {
        component: "main",
        children: /*#__PURE__*/_jsx(StyledContainerWrapper, {
          children: inline ? /*#__PURE__*/_jsx(Outlet, {}) : /*#__PURE__*/_jsx(StyledContainer, {
            fixed: true,
            children: /*#__PURE__*/_jsx(Outlet, {})
          })
        })
      }), /*#__PURE__*/_jsx(Footer, {
        isFooterVisible: isFooterVisible
      })]
    })
  });
};

export { PublicLayout };